
/**
 *
 * @param {string} selector
 * @param {document | Element} context
 * @returns {Element|null}
 */
export const get = ( selector, context = document ) => context.querySelector( selector );
/**
 *
 * @param {string} selector
 * @param {document | Element} context
 * @returns {NodeListOf<Element>}
 */
export const getAll = (selector, context = document) => context.querySelectorAll(selector);

export const toggleBooleanAttribute = (el, attr) => {
    el.setAttribute( attr, ( el.getAttribute( attr ) === 'true' ? 'false' : 'true' ) );
};


export function debounce( func, limit ) {
    let timeout;
    return ( ...args ) => {
        clearTimeout( timeout );
        timeout = setTimeout( func, limit, ...args );
    };
}
